<template>
	<svg
		width="14px"
		height="11px"
		viewBox="0 0 14 11"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		alt="observing eye icon"
	>
		<g
			id="Meetings"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g
				id="You-Are-Muted---Mute-&amp;-Unpin-Hover-State"
				transform="translate(-1384.000000, -625.000000)"
				fill="#787878"
			>
				<g id="Group-8" transform="translate(1130.000000, 71.000000)">
					<g
						id="show,-view,-eye,-visible,-on-copy-3"
						transform="translate(254.000000, 554.000000)"
					>
						<path
							d="M13.582976,5.2399162 C11.9650958,2.85610085 10.0313267,0.650216135 6.86342854,0.650216135 C3.69553037,0.650216135 1.76176125,2.85610085 0.143881121,5.2399162 C-0.0479603735,5.52311913 -0.0479603735,5.89179734 0.143881121,6.17500027 C1.76176125,8.55881562 3.69553037,10.7647003 6.86342854,10.7647003 C10.0313267,10.7647003 11.9650958,8.55864704 13.582976,6.17483169 C13.7747413,5.89166748 13.7747413,5.52308041 13.582976,5.2399162 Z M6.86342854,9.07895297 C5.04282009,9.07895297 3.62183437,8.12498853 1.89671328,5.70745824 C3.62183437,3.28984365 5.04282009,2.3359635 6.86342854,2.3359635 C8.68403699,2.3359635 10.1050227,3.28992794 11.8301438,5.70745824 C10.1050227,8.12507282 8.68403699,9.07895297 6.86342854,9.07895297 Z"
							id="Shape"
							fill-rule="nonzero"
						/>
						<path
							d="M6.9537145,3.77199997 C5.99360781,3.77199997 5.21528755,4.55032022 5.21528755,5.51042691 C5.21528755,6.4705336 5.99360781,7.24885385 6.9537145,7.24885385 C7.91382118,7.24885385 8.69214144,6.4705336 8.69214144,5.51042691 C8.69084863,4.55085623 7.91328518,3.77329277 6.9537145,3.77199997 L6.9537145,3.77199997 Z"
							id="Path"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'ObservingEye',
}
</script>
